"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.save = exports.restore = void 0;
const core = __importStar(require("@actions/core"));
const cache_utils_1 = require("./cache-utils");
const cache_base_1 = require("./cache-base");
const cache_cleaner_1 = require("./cache-cleaner");
const CACHE_RESTORED_VAR = 'GRADLE_BUILD_ACTION_CACHE_RESTORED';
function restore(userHome, gradleUserHome, cacheListener) {
    return __awaiter(this, void 0, void 0, function* () {
        if (process.env[CACHE_RESTORED_VAR]) {
            core.info('Cache only restored on first action step.');
            return;
        }
        core.exportVariable(CACHE_RESTORED_VAR, true);
        const gradleStateCache = new cache_base_1.GradleStateCache(userHome, gradleUserHome);
        if ((0, cache_utils_1.isCacheDisabled)()) {
            core.info('Cache is disabled: will not restore state from previous builds.');
            gradleStateCache.init();
            cacheListener.cacheDisabled = true;
            return;
        }
        if (gradleStateCache.cacheOutputExists()) {
            if (!(0, cache_utils_1.isCacheOverwriteExisting)()) {
                core.info('Gradle User Home already exists: will not restore from cache.');
                gradleStateCache.init();
                cacheListener.cacheDisabled = true;
                cacheListener.cacheDisabledReason = 'disabled due to pre-existing Gradle User Home';
                return;
            }
            core.info('Gradle User Home already exists: will overwrite with cached contents.');
        }
        gradleStateCache.init();
        core.saveState(CACHE_RESTORED_VAR, true);
        if ((0, cache_utils_1.isCacheWriteOnly)()) {
            core.info('Cache is write-only: will not restore from cache.');
            cacheListener.cacheWriteOnly = true;
            return;
        }
        yield core.group('Restore Gradle state from cache', () => __awaiter(this, void 0, void 0, function* () {
            yield gradleStateCache.restore(cacheListener);
        }));
        if ((0, cache_utils_1.isCacheCleanupEnabled)() && !(0, cache_utils_1.isCacheReadOnly)()) {
            core.info('Preparing cache for cleanup.');
            const cacheCleaner = new cache_cleaner_1.CacheCleaner(gradleUserHome, process.env['RUNNER_TEMP']);
            yield cacheCleaner.prepare();
        }
    });
}
exports.restore = restore;
function save(userHome, gradleUserHome, cacheListener, daemonController) {
    return __awaiter(this, void 0, void 0, function* () {
        if ((0, cache_utils_1.isCacheDisabled)()) {
            core.info('Cache is disabled: will not save state for later builds.');
            return;
        }
        if (!core.getState(CACHE_RESTORED_VAR)) {
            core.info('Cache will not be saved: not restored in main action step.');
            return;
        }
        if ((0, cache_utils_1.isCacheReadOnly)()) {
            core.info('Cache is read-only: will not save state for use in subsequent builds.');
            cacheListener.cacheReadOnly = true;
            return;
        }
        yield daemonController.stopAllDaemons();
        if ((0, cache_utils_1.isCacheCleanupEnabled)()) {
            core.info('Forcing cache cleanup.');
            const cacheCleaner = new cache_cleaner_1.CacheCleaner(gradleUserHome, process.env['RUNNER_TEMP']);
            try {
                yield cacheCleaner.forceCleanup();
            }
            catch (e) {
                core.warning(`Cache cleanup failed. Will continue. ${String(e)}`);
            }
        }
        yield core.group('Caching Gradle state', () => __awaiter(this, void 0, void 0, function* () {
            return new cache_base_1.GradleStateCache(userHome, gradleUserHome).save(cacheListener);
        }));
    });
}
exports.save = save;
